import { useNavigate } from "react-router-dom";
import { Button, Spinner } from "reactstrap";

export const BackButton = ({
  text = "Cancel",
}: {
  text?: "Cancel" | "Back";
}) => {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => navigate(-1)}
      type="button"
      className="btn w-sm btn-soft-danger"
    >
      {text}
    </Button>
  );
};

export const LoadingButton = ({
  text = "Please wait...",
}: {
  text?: string;
}) => {
  return (
    <Button
      color="primary"
      type="button"
      className="btn-load btn-soft-primary w-sm"
    >
      <span className="d-flex align-items-center">
        <Spinner size="sm" className="flex-shrink-0">
          Loading...{" "}
        </Spinner>
        <span className="flex-grow-1 ms-2">{text}</span>
      </span>
    </Button>
  );
};
